const creds = {
    backendURL: "https://tribedemo.expertsoftware.in/translate"
}

const API_URL = creds.backendURL;
export default API_URL;